var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.getListClass() },
    [
      !_vm.groupList.length ? _c("yxt-empty") : _vm._e(),
      _c("yxt-scrollbar", { ref: "scrollRef", attrs: { "fit-height": true } }, [
        _c(
          "div",
          { staticClass: "group-list_box" },
          _vm._l(_vm.groupList, function (group) {
            return _c("Item", {
              key: "grp_" + group.id,
              attrs: {
                info: group,
                mode: _vm.mode,
                id: _vm.id,
                dragging: _vm.dragging,
              },
              on: { select: _vm.onSelect },
            })
          }),
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }